import { AppBar, BrandLink, Hidden, Spacer } from "@generalapplications/ui";

import { site } from "@/content/site";
import { routes } from "@/app/common/functions/routes/routes";

import { BrandMark } from "./BrandMark";
import { DesktopNavigation } from "./DesktopNavigation";
import { MobileNavigation } from "./MobileNavigation";

/** The site bar: the brand, the sections (a sheet on a phone), Contact. */
export function SiteHeader() {
  return (
    <AppBar>
      <BrandLink
        href={routes.home}
        label="General Applications home"
        name={site.name}
      >
        <BrandMark />
      </BrandLink>
      <Spacer />
      <Hidden below="md" as="div">
        <DesktopNavigation />
      </Hidden>
      <MobileNavigation />
    </AppBar>
  );
}
